// extracted by mini-css-extract-plugin
module.exports = {"dialog":"_2DVNNZXhHHu73UWlhPehpt","subHeader":"_18XcRYt7sS9b3mC9w5Y4eD","body":"_3lPqU9zM4QCdbi2D8gzu0d"};